export class VPNGetRandomXandSignX {
    /** 亂數 */
    public RandomX: string = null;
    /** 簽章 */
    public SignX: string = null;
    // 以下為控制軟體6.0 所需欄位
    /** 簽章 */
    public signature: string = null;
    /** 簽章亂數 */
    public clientRandom: string = null;
    /** 安全模組編號 */
    public samId: string = null;
    /** 醫事機構代碼 */
    public hospitalId: string = null;
    /** 服務類別 */
    public serviceType: string = null;
    /** 醫事人員卡片編號 */
    public hpcId: string = null;
    /** 醫事人員身分證號 */
    public hpcIdNo: string = null;
    /** 健保卡卡片編號 */
    public hcId: string = null;
    /** 健保卡身分證號 */
    public hcIdNo: string = null;
}
